module.exports = __webpack_public_path__ + "img/savings.ea284fa5.svg";